import { IMenu, IMeta } from 'src/common/interfaces/index.js'
import businessClient from 'src/services/clients/business'

const IMenuListResponse = { meta: IMeta, data: { list: [IMenu] } }
const IMenuUpsertResponse = { meta: IMeta, data: { upsert: [IMenu] } }
const IMenuBulkUpdateResponse = { meta: IMeta, data: { update: [IMenu] } }
const IMenuArchiveResponse = { meta: IMeta, data: { archive: [IMenu] } }

export const menuMain = {
  /**
   * @param {{store_id: number, id: number}} filter
   * @return {Promise<IMenuListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('menu/portal/list', { filter }, { signal })
  },

  /**
   * @param {IMenu} data
   * @return {Promise<IMenuUpsertResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('menu/upsert', { data }, { signal })
  },

  /**
   * @param {{id: number}} filter
   * @return {Promise<IMenuArchiveResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('menu/archive', { filter }, { signal })
  },

  /**
   * @param {{ids: number[], is_active: boolean}} data
   * @return {Promise<IMenuBulkUpdateResponse>}
   */
  bulkUpdate(data, signal) {
    return businessClient().post('menu/bulk/update', { data }, { signal })
  },

  /**
   * @param {{menu_id: number}} filter
   * @returns {Promise<[{id: number, name: string}]>}
   */
  pairedSystems(filter, signal) {
    return businessClient().post('menu/publish/portal/page-setup', { filter }, { signal })
  },

  /**
   * @param {{menu_id: number, partner_id: number, store_ids: number[]}} filter
   */
  publish(filter, signal) {
    return businessClient().post('menu/publish', { filter }, { signal })
  },

  /**
   * @param {{menu_id: number}} filter
   */
  duplicate(filter, signal) {
    return businessClient().post('menu/duplicate', { filter }, { signal })
  },
}
